import { Component, OnInit, HostListener, ViewEncapsulation  } from '@angular/core';
import { formatNumber } from '@angular/common';
import * as Highcharts from "highcharts/highstock";
import { DistributionDataService } from '../../../services/distributionData.service';
import { PoolingPortalService } from '../../../services/pooling-portal.service';
import { FiltersService } from '../../../services/filters.service';
import { VesselsService } from '../../../services/vessels.service';
import { NavigationService } from '../../../services/navigation.service';
import { TceChart,LatestMonthYear, Filters, ToggleConfiguration } from '../../../interface/dashboard.interface';
import { Subscription } from 'rxjs'; 

@Component({
  selector: 'app-dashboard-chart',
  templateUrl: './dashboard-chart.component.html',
  styleUrls: ['./dashboard-chart.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DashboardChartComponent implements OnInit {

  public Highcharts:any = Highcharts;
  public chartOptions: Highcharts.Options = {};
  public chartOptionsNetPoolout: Highcharts.Options = {};
  public chartNetPoolOut: any;
  public chart:any;
  public chartCallbackNetPoolOut;
  public chartCallback;

  tceChart: TceChart = {
    minDate: 0,
    maxDate: 0,
    startMonthDate: new Date(),
    endMonthDate: new Date(),
    finMinDate: new Date(),
    finMaxDate: new Date(),
    load       : false,
    isHide:false,
    isCollapsed:false,
    isSkelton:false,
    tceSkelton: false,
    tceChartAction : 'ytd',
    lastMonthTceLabel:'',
    distributionData:[],
    allDistributionData:[],
    lastMonthTce : 0,
    ytdTce: 0,
    download:true,
    yAxisMaxData:0,
    averageTce:0,
    shipOwner:[],
    subpool:[],
    shipName:[],
    shipClass:[],
    shipSelected:[],
    vessels:[],
    owners:[],
    highchartsWidth:0,
    fleet: '',
    data:[],
    selectedRange:{
      startDate: '',
      endDate : ''
    },
    switchType:'Monthly',
    yearDateDropdown:false,
    monthDateDropdown:false,
    tceNotFoundMsg:false
  }

  netPooloutPerOpDayChart = {
    minDate: 0,
    maxDate: 0,
    dataNetPoolout: Number[0],
    distributionDataNetPoolout: [],
    allDistributionDataNetPoolout: [],
    yAxisMaxDataNetPoolout: 0,
    averageNetPoolout: 0,
    ytdNetPoolout: 0,
    lastMonthNetPoolout: 0,
    lastMonthNetPooloutLabel:''
  }
  
  latestMonthYear:LatestMonthYear ={
    finMaxDate: new Date(),
    finMinDate: new Date(),
    lastMonth: 0,
    lastUpdatedAt: new Date(),
    lastYear: 0,
    latestMonth: 0,
    latestYear: 0,
    minYear: 0,
    maxYear: 0
  }
  
  filters: Filters  = {
    ship: [],
    shipOwners: [],
    vslClass: [],
    subpool: [],
    vslNumber: [],
    shipOwnersPdf: [],
    subpoolPdf: []
  }

  ariaConfig: ToggleConfiguration = {
    ariaLabel: "Toggle Button Label",
    ariaDescribedBy: "aria described by",
    ariaHidden: false,
    role: "button",
    ariaDisable: false,
    id: "button_var"
  }

  monthNameArray = this._poolingPortalService.getMonthShortNames();
  subscription: Subscription;
  preSelectedval: any;
  shipNames: any = [];
  shipOwners: any = [];
  subPools: any = [];
  vslClasses: any = [];
  defaultActive: boolean = false;
  userRole = 0;
  fiscalYear;

  constructor(private _vesselService: VesselsService,
  private _distributionDataService: DistributionDataService,
  private _poolingPortalService: PoolingPortalService,
  private navService: NavigationService,
  private _filterService: FiltersService) { 
    const self:any = this;
    this.chartCallback = function(chart:any){
      self.chart = chart;
    };
    this.chartCallbackNetPoolOut = function(chart:any){
      self.chartNetPoolOut = chart;
    };
  }

  ngOnInit(){
    document.body.classList.add('addDatePickerClass')
    this.userRole = this.navService.getUserRole()
    this.tceChart.isSkelton = true;
    this.tceChart.tceSkelton = true;
    this.resetFilter();
    let highchartsWidth:any = document.getElementById('hightchart');
    this.tceChart.highchartsWidth = highchartsWidth.clientWidth - 30;
    this.subscription = this._poolingPortalService.fleet$.subscribe(
      fleet => {
        this.tceChart.tceChartAction = 'ytd';
        this.tceChart.switchType = 'Monthly';
        this.tceChart.isSkelton = true;
        this.tceChart.tceSkelton = true;
        this.tceChart.isHide = false;
        this.tceChart.load = false;
        this.tceChart.fleet = fleet;
        this.getOwnerList();
      }
    )
  }

  ngDoCheck() {
    if(this.tceChart.isCollapsed != this.navService.isNavigationCollapseByValue()){
      this.tceChart.isCollapsed = this.navService.isNavigationCollapseByValue();
      this.refreshTceChart();
      let highchartsWidth:any = document.getElementById('hightchart');
      this.tceChart.highchartsWidth = highchartsWidth.clientWidth - 20;
    }
  }

  getDashboardFinDates() {
    let formData = {"fleet": this.tceChart.fleet};
    this._distributionDataService.getDashboardFinDates(formData)
      .subscribe({
        next: (res:any) => {
          if(res.data.getDashboardFinDates.success){            
            this.latestMonthYear = res.data.getDashboardFinDates.data;
            /* this.tceChart.endMonthDate = new Date(this.latestMonthYear.latestYear + '-' + this.latestMonthYear.latestMonth.toString().padStart(2, "0"));
            this.tceChart.startMonthDate = new Date(this.latestMonthYear.lastYear + '-' + this.latestMonthYear.lastMonth.toString().padStart(2, "0")) */
            this.tceChart.endMonthDate = new Date(this.latestMonthYear.latestYear, this.latestMonthYear.latestMonth - 1 , 1);
            this.tceChart.startMonthDate = new Date(this.latestMonthYear.lastYear, this.latestMonthYear.lastMonth - 1, 1);
            const finMinDate = new Date(this.latestMonthYear.finMinDate);
            const finMaxDate = new Date(this.latestMonthYear.finMaxDate);
            this.tceChart.finMinDate = new Date(finMinDate.getUTCFullYear(), finMinDate.getUTCMonth(), finMinDate.getUTCDate());
            this.tceChart.finMaxDate = new Date(finMaxDate.getUTCFullYear(), finMaxDate.getUTCMonth(), finMaxDate.getUTCDate());
            console.log('endMonthDate', this.tceChart.endMonthDate)
            console.log('startMonthDate', this.tceChart.startMonthDate)
            console.log('finMinDate', this.tceChart.finMinDate)
            console.log('finMaxDate', this.tceChart.finMaxDate)
            this.fiscalYear = res.data.getDashboardFinDates.data.fiscalYear;
            this.getDashboardFilters();
            this.tceChartSelected(this.tceChart.tceChartAction);
          }
        }
      });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event:any) {
    this.refreshTceChart();
    let highchartsWidth:any = document.getElementById('hightchart');
    this.tceChart.highchartsWidth = highchartsWidth.clientWidth - 20;   
  }

  getOwnerList() {
    this._distributionDataService.getOwnerList(this.tceChart.fleet)
      .subscribe({
        next: (res:any) => {
          this.tceChart.owners = res.data.getOwnersList.data;
          this.tceChart.owners = this.tceChart.owners.map((items:any)=>({id:items?.value,name:items.label}))
          this.tceChart.shipOwner = this._filterService.shipOwners(this.tceChart.vessels,this.filters,this.tceChart.owners);
          this.getDashboardFinDates();
        }
      });
  }

  refreshTceChart(){
    this.tceChart.isHide = false;
    let that = this;
    setTimeout(function(){
      that.tceChart.isHide = true;
      that.tceChartSelected(that.tceChart.tceChartAction);
    }, 1);
  }

  getDashboardFilters() {
    let formData = {
      "fleet":this.tceChart.fleet,
      'action':this.tceChart.tceChartAction,
      "switchType": this.tceChart.switchType,
    };
    if(this.tceChart.switchType == "Monthly"){
      if(this.tceChart.tceChartAction == 'ytd'){
        formData['month'] = this.latestMonthYear.latestMonth
        formData['year'] = this.latestMonthYear.latestYear
      }
      else if(this.tceChart.tceChartAction == 'finMonthYear'){
        formData['startDate'] = this.tceChart.selectedRange.startDate
        formData['endDate'] = this.tceChart.selectedRange.endDate
      }
      else{
        formData['year'] = this.latestMonthYear.latestYear
      }
    }
    else{
      if(this.tceChart.tceChartAction == 'finMonthYear'){
        formData['startYear'] = this.tceChart.selectedRange.startDate
        formData['endYear'] = this.tceChart.selectedRange.endDate
      }
    }   
    
    this._vesselService.getDashboardFilters(formData)
      .subscribe({
        next: (res:any) => {
          if(res.data.getDashboardFilters.success){
            this.tceChart.isSkelton = false;
            this.tceChart.vessels = res.data.getDashboardFilters.data;
          
            if(this.tceChart.owners?.length > 0){                 
              if(this.filters.ship['selectedRecords']?.length){
                this.filters.ship = this.filters.ship['selectedRecords'].map((record: any) => record.name);
              }
              this.tceChart.shipOwner = this._filterService.shipOwners(this.tceChart.vessels,this.filters,this.tceChart.owners);
              this.tceChart.shipOwner =  this.tceChart.shipOwner.filter((obj:any, index:any, self:any) => index === self.findIndex((x:any) => x.id === obj.id));
            }
            this.tceChart.subpool = this._filterService.subpools(this.tceChart.vessels,this.filters);
            this.tceChart.subpool =  this.tceChart.subpool.filter((obj:any, index:any, self:any) => index === self.findIndex((x:any) => x.id === obj.id));
            this.tceChart.shipClass = this._filterService.vslClass(this.tceChart.vessels,this.filters);
            this.tceChart.shipClass = this.tceChart.shipClass.filter((obj:any, index:any, self:any) => index === self.findIndex((x:any) => x.id === obj.id));
            this.tceChart.shipName  = this._filterService.ships(this.tceChart.vessels,this.filters);
          }
        }
      });
  }  
  
  getDistributionRevenue(filter = '') {
    let formData = {
      "vslOwner":  this.filters['shipOwners'].toString(),
      "subPool": this.filters['subpool'].toString(),
      "vslName": this.filters['ship'].toString(),
      "vslClass": this.filters['vslClass'].toString(),
      "fleet":this.tceChart.fleet,
      "switchType": this.tceChart.switchType,
      'action':this.tceChart.tceChartAction,
      'year' : this.latestMonthYear.latestYear,
      'month' : this.latestMonthYear.latestMonth
    };
    if(this.tceChart.tceChartAction == 'finMonthYear'){
      formData['startDate'] = this.tceChart.selectedRange.startDate
      formData['endDate'] = this.tceChart.selectedRange.endDate
    }
    if(this.userRole === 1){ // TCE chart only for pool manager
      this._distributionDataService.getDistributionRevenue(formData)
        .subscribe({
          next: (res:any) => {
            //this.tceChart.tceSkelton = false;
            this.tceChart.allDistributionData = res.data.getDistributionRevenue.data;
            this.tceChart.distributionData = this.tceChart.allDistributionData;
            this.tceChart.ytdTce = res.data.getDistributionRevenue.ytdTce;
            this.loadChartData(filter);
          },
          error: (error) => {
            /* this.tceChart.isSkelton = false;
            this.tceChart.tceSkelton = false; */
          }
        });
    }

    this._distributionDataService.getNetPooloutPerOpDayChart(formData)
      .subscribe({
        next: (res:any) => {
          this.tceChart.tceSkelton = false;
          this.netPooloutPerOpDayChart.allDistributionDataNetPoolout = res.data.getDistributionNetPoolOut.data;
          this.netPooloutPerOpDayChart.distributionDataNetPoolout = this.netPooloutPerOpDayChart.allDistributionDataNetPoolout;
          this.netPooloutPerOpDayChart.ytdNetPoolout = res.data.getDistributionNetPoolOut.ytdNetPoolOut;
          this.loadChartDataNetPoolout(filter);
        },
        error: (error) => {
          /* this.tceChart.isSkelton = false;
          this.tceChart.tceSkelton = false; */
        }
      });
  }

  selectedValues(event:any,field:string){
    this.filters[field] = event.selectedRecords?.map((items:any) =>items?.id);
    if(field === 'ship'){
      this.shipNames =  this.filters[field]?.map((items:any) =>({id:items,name:items}))
    }
    else if(field == 'shipOwners'){
      this.filters['shipOwnersPdf'] = event;
      this.shipOwners =  this.filters[field]?.map((items:any) =>({id:items,name:items}))
    }
    else if(field == 'subpool'){
      this.filters['subpoolPdf'] = event;
       this.subPools =  this.filters[field]?.map((items:any) =>({id:items,name:items}))
    }
    else if(field == 'vslClass'){
      this.vslClasses = this.filters[field]?.map((items:any) =>({id:items,name:items}))
    }
    this.tceChartSelected(this.tceChart.tceChartAction,'filter');
    this.refreshDropdownData();
  }

  resetDropdown(event:any,field:string){
    this.filters[field] = [];
    if(field == 'shipOwners'){
      this.filters['shipOwnersPdf'] = [];
    }
    else if(field == 'subpool'){
      this.filters['subpoolPdf'] = [];
    }
    else if(field == 'vslClass'){
      this.vslClasses = [];
    }
    this.refreshDropdownData();
    this.tceChartSelected(this.tceChart.tceChartAction,'filter');
  }

  resetFilter(){
    let filterObj = ['ship','shipOwners','vslClass','subpool','vslNumber','shipOwnersPdf','subpoolPdf']
    filterObj.forEach( (it: any) => {
      this.filters[it] = [];
    });
    this.shipNames = [];
    this.shipOwners = [];
    this.subPools = [];
    this.vslClasses = [];
  }

  resetAll(){
    this.resetFilter();
    this.tceChartSelected(this.tceChart.tceChartAction,'filter');
    this.refreshDropdownData();
    this.shipNames = [];
    this.shipOwners = [];
    this.subPools = [];
    this.vslClasses = [];
  }

  public refreshDropdownData(){
    this.tceChart.shipOwner = this._filterService.shipOwners(this.tceChart.vessels,this.filters,this.tceChart.owners);
    this.tceChart.subpool = this._filterService.subpools(this.tceChart.vessels,this.filters);
    this.tceChart.shipClass = this._filterService.vslClass(this.tceChart.vessels,this.filters);
    this.tceChart.shipName  = this._filterService.ships(this.tceChart.vessels,this.filters);
  }

  resetActivate(){
    return (this.filters['shipOwners'].length > 0 || this.filters['subpool'].length > 0 || this.filters['ship'].length > 0 || this.filters['vslClass'].length > 0) ? true : false;
  }

  filterVessels() {
    return  this.tceChart.vessels.filter((item:any) => {
      const shipOwners: boolean = this.filters.shipOwners.reduce((prev:any, curr:string, currentIndex:number) => { 
        if (item.vslOwner && item.vslOwner.includes(curr)) {
          return true;
        }
        else if(currentIndex == 0) {
          return false;
        }
        else {
          return prev;
        }
      }, true);
      return shipOwners;// return true        
    });    
  }

  public tceChartSelected(action, filter=''){
    this.tceChart.tceChartAction = action;
    this.tceChart.isHide = false;
    this.tceChart.tceSkelton = true;
      if(this.tceChart.switchType == 'Yearly' && action != 'finMonthYear'){
          this.tceChart.yearDateDropdown = false;
      }
      else if(this.tceChart.switchType == 'Monthly' && action != 'finMonthYear'){
        this.tceChart.monthDateDropdown = false;
      }
      let that = this;      

      if(this.tceChart.switchType == 'Monthly'){
        this.getDistributionRevenue(filter);
      }
      else{
        if(this.userRole === 1){ // TCE chart only for pool manager
          this.loadYearlyData(filter);
        }
        this.loadYearlyDataNetPoolout(filter)
      }

      this.getDashboardFilters();
      setTimeout(function(){
        that.tceChart.isHide = true;
        that.tceChart.yearDateDropdown = true;
        that.tceChart.monthDateDropdown = true;
      }, 1);
  }

  loadYearlyDataNetPoolout(filter = ''){
    let formData = {
      "vslOwner":  this.filters['shipOwners'].toString(),
      "subPool": this.filters['subpool'].toString(),
      "vslName": this.filters['ship'].toString(),
      "vslClass": this.filters['vslClass'].toString(),
      "fleet":this.tceChart.fleet,
      "switchType": this.tceChart.switchType,
      'action':this.tceChart.tceChartAction,
    };
    if(this.tceChart.tceChartAction == 'finMonthYear'){
      formData['startYear'] = this.tceChart.selectedRange.startDate
      formData['endYear'] = this.tceChart.selectedRange.endDate
    }

    this._distributionDataService.getYearlyNetPooloutPerOpDayChart(formData)
    .subscribe({
      next: (res:any) => {
        this.tceChart.tceSkelton = false;
        //net pool out data available from 2021, previous year should be added as 0
        let responseData = res.data.getYearlyDistributionNetPoolOut.data;
        const startYear = formData['startYear'];
        const endYear = formData['endYear'];
        for(let i = endYear; i >= startYear; i--){
          if(responseData.findIndex(x => x['year'] == i) === -1){
            let newElement = {};
            newElement['year'] = i;
            newElement['totalOpDaysYTD'] = 0;
            newElement['totalNetPoolOutYTD'] = 0;
            //newElement['NetPoolOutPerOpdaysAmtPerYear'] = 0;
            responseData = [newElement, ...responseData]
          }
        }
        this.netPooloutPerOpDayChart.allDistributionDataNetPoolout = responseData;
        this.netPooloutPerOpDayChart.distributionDataNetPoolout = this.netPooloutPerOpDayChart.allDistributionDataNetPoolout;
        this.netPooloutPerOpDayChart.ytdNetPoolout = res.data.getYearlyDistributionNetPoolOut.ytdNetPoolOut;
        this.loadChartDataNetPoolout(filter);
      },
      error: (error) => {
        this.tceChart.tceSkelton = false;
      }
    });
  }

  loadChartDataNetPoolout(filter = ''){
    this.netPooloutPerOpDayChart.dataNetPoolout = [];
    if(this.netPooloutPerOpDayChart.distributionDataNetPoolout.length > 0)
    {
      this.netPooloutPerOpDayChart.yAxisMaxDataNetPoolout = 0;
      this.netPooloutPerOpDayChart.averageNetPoolout = 0;
      let latestMonth:number = this.netPooloutPerOpDayChart.distributionDataNetPoolout[this.netPooloutPerOpDayChart.distributionDataNetPoolout.length - 1]['month'];
      let latestYear:number = this.netPooloutPerOpDayChart.distributionDataNetPoolout[this.netPooloutPerOpDayChart.distributionDataNetPoolout.length - 1]['year'];
      let monthNameArray = this._poolingPortalService.getMonthNames();
      this.netPooloutPerOpDayChart.lastMonthNetPooloutLabel = monthNameArray[latestMonth - 1];
      if(this.tceChart.switchType == 'Monthly'){
        this.loadChartMonthNetPoolout(latestYear,latestMonth);
      }
      else{
        this.loadChartYearlyNetPoolout();
      }
      this.netPooloutPerOpDayChart.yAxisMaxDataNetPoolout = (this.netPooloutPerOpDayChart.ytdNetPoolout > this.netPooloutPerOpDayChart.yAxisMaxDataNetPoolout) ? this.netPooloutPerOpDayChart.ytdNetPoolout : this.netPooloutPerOpDayChart.yAxisMaxDataNetPoolout;
    }
   
    this.tceChart.load = true;
    
    /*load Highchart */
    this.loadChartOptionNetPoolout();
    let that = this;
    setTimeout(function(){
      that.loadPlotLineNetPoolOut();
    }, 1);    
  }

  loadChartMonthNetPoolout(latestYear,latestMonth){
      /* Highchart landing data date range */
      this.netPooloutPerOpDayChart.minDate = Date.UTC(this.netPooloutPerOpDayChart.distributionDataNetPoolout[0]['year'], this.netPooloutPerOpDayChart.distributionDataNetPoolout[0]['month'] - 1, 1);
      this.netPooloutPerOpDayChart.maxDate = Date.UTC(latestYear, latestMonth - 1, 1);
      let averageNetPoolout = 0
      let avgNetPooloutCount = 0;      
      this.netPooloutPerOpDayChart.distributionDataNetPoolout.forEach( (it: any) => {
        let revenue = 0;
        let totalOpdays = 0;
        if(it.totalOpdays > 0 && it.totalnetPoolOut > 0){
          totalOpdays = Number(parseFloat(it.totalOpdays).toFixed(2));
          revenue = it.totalnetPoolOut / totalOpdays;
          //revenue = it.totalnetPoolOut
        }        
        if(revenue > this.netPooloutPerOpDayChart.yAxisMaxDataNetPoolout){
          this.netPooloutPerOpDayChart.yAxisMaxDataNetPoolout = revenue;
        }
        this.netPooloutPerOpDayChart.dataNetPoolout.push([Date.UTC(it['year'], it['month'] - 1,), revenue]);
        avgNetPooloutCount++ ;
        averageNetPoolout = averageNetPoolout + revenue;
        if(it.year === latestYear && it.month === latestMonth){
          this.netPooloutPerOpDayChart.lastMonthNetPoolout = it.totalnetPoolOut / totalOpdays;
          //this.netPooloutPerOpDayChart.lastMonthNetPoolout = it.totalnetPoolOut;
        }
      });
      if(this.tceChart.tceChartAction == 'ytd'){
        this.netPooloutPerOpDayChart.averageNetPoolout = averageNetPoolout / avgNetPooloutCount;
      }
  }

  loadChartYearlyNetPoolout(){
    //A record with a missing fiscal year comes back with year null, it must not drive the axis or discard the rest of the series
    const yearlyData = this.netPooloutPerOpDayChart.distributionDataNetPoolout.filter((it: any) => it['year'] != null && Number.isFinite(Number(it['year'])));
    if(yearlyData.length === 0){
      return;
    }
    let startYear:any = yearlyData[0]['year'];
    this.netPooloutPerOpDayChart.minDate = Date.UTC(startYear, 0, 2);
    this.netPooloutPerOpDayChart.maxDate =  Date.UTC(yearlyData[yearlyData.length - 1]['year'], 0, 2);

    yearlyData.forEach( (it: any) => {
      if(it['year'] >= startYear){
         let totalOpdays = Number(parseFloat(it['totalOpDaysYTD']).toFixed(2));
         let revenueYTD = totalOpdays > 0 ? it['totalNetPoolOutYTD'] / totalOpdays : 0;
         if(revenueYTD > this.netPooloutPerOpDayChart.yAxisMaxDataNetPoolout){
            this.netPooloutPerOpDayChart.yAxisMaxDataNetPoolout = revenueYTD;
         }
        this.netPooloutPerOpDayChart.dataNetPoolout.push([Date.UTC(it['year'], 0,2), revenueYTD]);
      }
    });
  }

  loadChartOptionNetPoolout(){
    console.log(this.netPooloutPerOpDayChart);
    let component = this;
    this.chartOptionsNetPoolout = {
      rangeSelector: {
        enabled: false,
        labelStyle: {display: 'none'},
       },
      scrollbar: {
        enabled: this.netPooloutPerOpDayChart.minDate != this.netPooloutPerOpDayChart.maxDate,
        liveRedraw: false,
        rifleColor:"none",
        zIndex:3,
        barBackgroundColor:"#DBE3ED",
        barBorderColor:"#DBE3ED",
        barBorderRadius:5,
        height:8,
      },
      
      xAxis :[
        {
          min : this.netPooloutPerOpDayChart.minDate,   
          max: this.netPooloutPerOpDayChart.maxDate,
          lineWidth: 0,
          tickLength: 0,
          ordinal: true,
          lineColor: '#DBE3ED',
          type: 'datetime',
          tickPositioner: function() { return component.xAxisTickPositioner(this); },
          labels:{
            align:'center',
            useHTML: false,
            formatter: function(e:any) {
                let vDate =  new Date(e.value);
                if(vDate.getDate() == 2 || component.tceChart.switchType == 'Yearly'){
                  let label = Highcharts.dateFormat('%Y',e.value);
                  if(e.axis.max == e.value){
                    label = '<div class = "lastLabel">' +  Highcharts.dateFormat('%Y',e.value) + '</div>'
                  }
                  return label;
                }
                else{
                  let value = Highcharts.dateFormat('%b',e.value)  + " " + Highcharts.dateFormat('%y',e.value);
                  let label = value;
                  if(e.axis.max == e.value){
                    label = '<div class = "lastLabel">' +  value + '</div>'
                  }
                  return label;
                }
            },
            style: {
              fontSize: '12px',
              color: '#64748B',
              lineHeigt:'16px',
              
            }
          },
        },
      ],
      yAxis: [
        {
          max:this.netPooloutPerOpDayChart.yAxisMaxDataNetPoolout,
          opposite:false,
          showFirstLabel: true,
          showLastLabel: true,
          gridLineColor: '#DBE3ED',
          gridLineDashStyle: 'LongDash',
          lineWidth: 1,
          labels:{
            x:-11,
            y:1,
            useHTML: false,
            formatter: function(e:any) {
              return '<div class = "yAxis">' +  '$ ' + formatNumber(e.value,'en','1.0-2') + '</div>'
              
            },
            style: {
              wordWrap: 'break-word',
              fontSize: '14px',
              color: '#64748B',
              lineHeigt:'16px',
              fontWeight:'400',
              whiteSpace:"0.2px",
            },
          },
        },{
          lineWidth: 1,
        },
        {
          labels: {align: 'right',x: -1},
          title: {text: ' '},
          top: '65%',
          height: '35%',
          offset: 0,
          lineWidth: 0
      }
      
      ],
      navigator: {
        height: 30,
        margin: 15,
        enabled: false,
        maskFill: 'rgba(229, 244, 250, 0.50)',
        maskInside: true,
        outlineColor: '#DBE3ED',
        outlineWidth: 0,
        xAxis: {
          gridLineWidth: 0,
          labels: {
            align: 'left',
            x: 1,
            y: -10,
           formatter: function(e:any) {
              let data = this;
              let dataMin:any = new Date(data.axis['dataMin']);
              let dataMax:any = new Date(data.axis['dataMax']);
              if(dataMin.getDate() == 2 || dataMax.getDate() == 2 || component.tceChart.switchType == 'Yearly'){
                return Highcharts.dateFormat('%Y',e.value);
              }
              else{
                return Highcharts.dateFormat('%b',e.value)  + " '" + Highcharts.dateFormat('%y',e.value);
              }
            },
            style: {
              color: '#64748B',
              fontSize:'12px',
              fontWeight:'700',
              laterHeight:'16px',
              align: 'center',
              verticalAlign: 'top',
            }
          }
        },
        series: {
          color: 'rgba(219, 227, 237, 0.17)',
          lineWidth: 1
        },
        handles: {
          lineWidth: 1,
          width: 26,
          height: 28,
          borderColor:'#008ECF',
          backgroundColor: 'white',          
        }        
      },
      plotOptions: {
       area: {
            lineColor: "#008ECF",
            lineWidth: 1,
            marker: {
              lineWidth: 3,
              lineColor: "#008ECF",
              fillColor: '#008ECF',
              fillOpacity: 0.1,
              states: {
                hover: {
                  lineWidth: 5,
                  fillColor: '#008ECF',
                }
            }
          }
        },
      },
      chart: {
        spacingBottom: 10,
        spacingTop: 77,
        height: 570,
        events: {
          render() {
            const chart:any = this;
            if(chart?.series.length > 0){
              let selectpoints:any = [];
              let points = chart.series[0].points;
              points.forEach( (it: any) => {
                if(chart.xAxis[0].max >= it.category){
                  selectpoints.push(it.y) 
                }
              });
              const sum = selectpoints.reduce((acc:any, point:any) => acc + point, 0);
              const average:any = sum / selectpoints.length;
              chart.yAxis[0].removePlotLine('averageNetPoolOut');
              chart.yAxis[0].addPlotLine({
                value: average.toFixed(2,'1.2-2'),
                color: '#ECCBD9',
                id:'averageNetPoolOut',
                width: 4,
              });

              let avgNetPoolOut = document.getElementsByClassName('avgNetPoolOut');
              if (avgNetPoolOut.length > 0) {
                document.getElementsByClassName("avgNetPoolOut")[0].textContent = '$'+formatNumber(average.toFixed(2,'1.2-2'),'en');
              }
            }
          },
          load: function() {
            let chart = this;
            let dateUTC =  chart.series[0].data.length > 0 ? chart.series[0].data[chart.series[0].data.length - 1].category : 0;
            const lastDataPoint = new Date(dateUTC);
            let type = (lastDataPoint.getDate() == 1) ? "month" : "year";
            const PrevYear = new Date(`1/1/${lastDataPoint.getFullYear() - 10}`);
            if(type == 'year' && chart.series[0].data.length >=10){
              chart.xAxis[0].setExtremes(
                PrevYear.getTime(),
                lastDataPoint.getTime(),
                true
              );
            }
            else if(chart.series[0].data.length >=12){
              let d = new Date(dateUTC);
              d.setMonth(d.getMonth() - 11);
              const PrevYear = new Date(d.toLocaleDateString())
              chart.xAxis[0].setExtremes(
                PrevYear.getTime(),
                lastDataPoint.getTime(),
                true
              );
            }
          }
        }
      },
      tooltip: {
        shared: false,
        backgroundColor: '#ffff',
        borderColor: '#ffff',
        borderRadius: 4,
        useHTML :true,
        positioner: function(labelWidth, labelHeight, point) {
          let tooltipX = point.plotX - 20;
          let tooltipY = point.plotY - 50;
          if(tooltipX > 800){
            tooltipX = point.plotX - 160
          }
          return {
              x: tooltipX,
              y: tooltipY
          };
        },
        formatter: function() {
          let chart:any = this;
          let date:any = new Date(chart.x);
          let month = date.toLocaleString('en-US', { month: 'short', timeZone: 'UTC' });
          if(date.getDate() == 2 || component.tceChart.switchType == 'Yearly'){
            month = date.getFullYear();
          }
          let html = '<b style="padding:10px 16px;color:#27364B;font-size:16px;background-color: #fff">' + month +' Net pool out'+ ': $ '  + formatNumber(chart.y.toFixed(0),'en') + '</b>';
          return html;
        }
      },
      
      series: [{
        data: this.netPooloutPerOpDayChart.dataNetPoolout,
        type: 'area',
        marker: {
          enabled: true,
          radius: 3
        },
        color: {
          linearGradient: { x1:0, x2: 0, y1: 0, y2: 1 },
          stops: [
            [0, 'rgb(148, 163, 184,0.3)'],
            [1, 'rgb(148, 163, 184,0.01)'],
          ]
        }
      }]
    }
    this.loadPlotLineNetPoolOut();
  }

  loadYearlyData(filter = ''){
    let formData = {
      "vslOwner":  this.filters['shipOwners'].toString(),
      "subPool": this.filters['subpool'].toString(),
      "vslName": this.filters['ship'].toString(), 
      "vslClass": this.filters['vslClass'].toString(),
      "fleet":this.tceChart.fleet,
      "switchType": this.tceChart.switchType,
      'action':this.tceChart.tceChartAction,
    };
    if(this.tceChart.tceChartAction == 'finMonthYear'){
      formData['startYear'] = this.tceChart.selectedRange.startDate
      formData['endYear'] = this.tceChart.selectedRange.endDate
    }

    this._distributionDataService.getYearlyDistributionRevenue(formData)
    .subscribe({
      next: (res:any) => {
        this.tceChart.tceSkelton = false;
        this.tceChart.allDistributionData = res.data.getYearlyDistributionRevenue.data;
        this.tceChart.distributionData = this.tceChart.allDistributionData;
        this.tceChart.ytdTce = res.data.getYearlyDistributionRevenue.ytdTce;
        this.loadChartData(filter);
      },
      error: (error) => {
        this.tceChart.tceSkelton = false;
      }
    });
  }

  loadChartData(filter = ''){
    this.tceChart.data = [];
    if(this.tceChart.distributionData.length > 0)
    {
      this.tceChart.yAxisMaxData = 0;
      this.tceChart.averageTce = 0;
      let latestMonth:number = this.tceChart.distributionData[this.tceChart.distributionData.length - 1]['month'];
      let latestYear:number = this.tceChart.distributionData[this.tceChart.distributionData.length - 1]['year'];
      let monthNameArray = this._poolingPortalService.getMonthNames();
      this.tceChart.lastMonthTceLabel = monthNameArray[latestMonth - 1];
      if(this.tceChart.switchType == 'Monthly'){
        this.loadChartMonth(latestYear,latestMonth);
      }
      else{
        this.loadChartYearly();
      }
      this.tceChart.yAxisMaxData = (this.tceChart.ytdTce > this.tceChart.yAxisMaxData) ? this.tceChart.ytdTce  : this.tceChart.yAxisMaxData ;
    }
   
    this.tceChart.load = true;
    
    /*load Highchart */
    this.loadChartOption();
    let that = this;
    setTimeout(function(){
      that.loadPlotLine();
    }, 1);    
  }

  loadChartMonth(latestYear,latestMonth){
      /* Highchart landing data date range */
      this.tceChart.minDate = Date.UTC(this.tceChart.distributionData[0]['year'], this.tceChart.distributionData[0]['month'] - 1, 1);
      this.tceChart.maxDate = Date.UTC(latestYear, latestMonth - 1, 1);
      let averageTce = 0
      let avgTceCount = 0;      
      this.tceChart.distributionData.forEach( (it: any) => {
        let revenue = 0;
        let totalOpdays = 0;
        if(it.totalOpdays > 0){
          totalOpdays = Number(parseFloat(it.totalOpdays).toFixed(2));
          revenue = it.totalDistribution / totalOpdays;
        }        
        if(revenue > this.tceChart.yAxisMaxData){
          this.tceChart.yAxisMaxData = revenue;
        }
        this.tceChart.data.push([Date.UTC(it['year'], it['month'] - 1,), revenue]);
        avgTceCount++ ;
        averageTce = averageTce + revenue;
        if(it.year === latestYear && it.month === latestMonth){
          this.tceChart.lastMonthTce = it.totalDistribution / totalOpdays;
        }
      });
      if(this.tceChart.tceChartAction == 'ytd'){
        this.tceChart.averageTce = +(averageTce / avgTceCount).toFixed(2); 
      }
  }

  loadChartYearly(){
    this.tceChart.minDate = Date.UTC(this.tceChart.distributionData[0]['year'], 0, 2);
    this.tceChart.maxDate =  Date.UTC(this.tceChart.distributionData[this.tceChart.distributionData.length - 1]['year'], 0, 2);
    let startYear:any = this.tceChart.distributionData[0]['year'];
    this.tceChart.distributionData.forEach( (it: any) => {
      if(startYear && it['year'] >= startYear){
         let totalOpdays = Number(parseFloat(it['totalOpDaysYTD']).toFixed(2));
         let revenueYTD = totalOpdays > 0 ? it['totaldistAmtYTD'] / totalOpdays : 0;
         if(revenueYTD > this.tceChart.yAxisMaxData){
            this.tceChart.yAxisMaxData = revenueYTD;
         }
        this.tceChart.data.push([Date.UTC(it['year'], 0,2), revenueYTD]);
      }
   });
  }

  loadChartOption(){
    console.log(this.tceChart);
    let component = this;
    this.chartOptions = {
      rangeSelector: {
        enabled: false,
        labelStyle: {display: 'none'},
       },
      scrollbar: {
        enabled: this.tceChart.minDate != this.tceChart.maxDate,
        liveRedraw: false,
        rifleColor:"none",
        zIndex:3,
        barBackgroundColor:"#DBE3ED",
        barBorderColor:"#DBE3ED",
        barBorderRadius:5,
        height:8,
      },
      
      xAxis :[
        {
          min : this.tceChart.minDate,   
          max: this.tceChart.maxDate,
          lineWidth: 0,
          tickLength: 0,
          ordinal: true,
          lineColor: '#DBE3ED',
          type: 'datetime',
          tickPositioner: function() { return component.xAxisTickPositioner(this); },
          labels:{
            align:'center',
            useHTML: false,
            formatter: function(e:any) {
                let vDate =  new Date(e.value);
                if(vDate.getDate() == 2 || component.tceChart.switchType == 'Yearly'){
                  let label = Highcharts.dateFormat('%Y',e.value);
                  if(e.axis.max == e.value){
                    label = '<div class = "lastLabel">' +  Highcharts.dateFormat('%Y',e.value) + '</div>'
                  }
                  return label;
                }
                else{
                  let value = Highcharts.dateFormat('%b',e.value)  + " " + Highcharts.dateFormat('%y',e.value);
                  let label = value;
                  if(e.axis.max == e.value){
                    label = '<div class = "lastLabel">' +  value + '</div>'
                  }
                  return label;
                }
            },
            style: {
              fontSize: '12px',
              color: '#64748B',
              lineHeigt:'16px',
              
            }
          },
        },
      ],
      yAxis: [
        {
          max:this.tceChart.yAxisMaxData,
          opposite:false,
          showFirstLabel: true,
          showLastLabel: true,
          gridLineColor: '#DBE3ED',
          gridLineDashStyle: 'LongDash',
          lineWidth: 1,
          labels:{
            x:-11,
            y:1,
            useHTML: false,
            formatter: function(e:any) {
              return '<div class = "yAxis">' +  '$ ' + formatNumber(e.value,'en','1.0-2') + '</div>'
              
            },
            style: {
              wordWrap: 'break-word',
              fontSize: '14px',
              color: '#64748B',
              lineHeigt:'16px',
              fontWeight:'400',
              whiteSpace:"0.2px",
            },
          },
        },{
          lineWidth: 1,
        },
        {
          labels: {align: 'right',x: -1},
          title: {text: ' '},
          top: '65%',
          height: '35%',
          offset: 0,
          lineWidth: 0
      }
      
      ],
      navigator: {
        height: 30,
        margin: 15,
        enabled: false,
        maskFill: 'rgba(229, 244, 250, 0.50)',
        maskInside: true,
        outlineColor: '#DBE3ED',
        outlineWidth: 0,
        xAxis: {
          gridLineWidth: 0,
          labels: {
            align: 'left',
            x: 1,
            y: -10,
           formatter: function(e:any) {
              let data = this;
              let dataMin:any = new Date(data.axis['dataMin']);
              let dataMax:any = new Date(data.axis['dataMax']);
              if(dataMin.getDate() == 2 || dataMax.getDate() == 2 || component.tceChart.switchType == 'Yearly'){
                return Highcharts.dateFormat('%Y',e.value);
              }
              else{
                return Highcharts.dateFormat('%b',e.value)  + " '" + Highcharts.dateFormat('%y',e.value);
              }
            },
            style: {
              color: '#64748B',
              fontSize:'12px',
              fontWeight:'700',
              laterHeight:'16px',
              align: 'center',
              verticalAlign: 'top',
            }
          }
        },
        series: {
          color: 'rgba(219, 227, 237, 0.17)',
          lineWidth: 1
        },
        handles: {
          lineWidth: 1,
          width: 26,
          height: 28,
          borderColor:'#008ECF',
          backgroundColor: 'white',          
        }        
      },
      plotOptions: {
       area: {
            lineColor: "#008ECF",
            lineWidth: 1,
            marker: {
              lineWidth: 3,
              lineColor: "#008ECF",
              fillColor: '#008ECF',
              fillOpacity: 0.1,
              states: {
                hover: {
                  lineWidth: 5,
                  fillColor: '#008ECF',
                }
            }
          }
        },
      },
      chart: {
        spacingBottom: 10,
        spacingTop: 77,
        height: 570,
        events: {
          render() {
            const chart:any = this;
            if(chart?.series.length > 0){
              let selectpoints:any = [];
              let points = chart.series[0].points;
              points.forEach( (it: any) => {
                if(chart.xAxis[0].max >= it.category){
                  selectpoints.push(it.y) 
                }
              });
              const sum = selectpoints.reduce((acc:any, point:any) => acc + point, 0);
              const average:any = sum / selectpoints.length;
              chart.yAxis[0].removePlotLine('average');
              chart.yAxis[0].addPlotLine({
                value: average.toFixed(2,'1.2-2'),
                color: '#ECCBD9',
                id:'average',
                width: 4,
              });

              let avgTce = document.getElementsByClassName('avgTce');
              if (avgTce.length > 0) {
                document.getElementsByClassName("avgTce")[0].textContent = '$'+formatNumber(average.toFixed(2,'1.2-2'),'en');
              }
          }
          },
          load: function() {
            let chart = this;
            let dateUTC =  chart.series[0].data.length > 0 ? chart.series[0].data[chart.series[0].data.length - 1].category : 0;
            const lastDataPoint = new Date(dateUTC);
            let type = (lastDataPoint.getDate() == 1) ? "month" : "year";
            const PrevYear = new Date(`1/1/${lastDataPoint.getFullYear() - 10}`);
            if(type == 'year' && chart.series[0].data.length >=10){
              chart.xAxis[0].setExtremes(
                PrevYear.getTime(),
                lastDataPoint.getTime(),
                true
              );
            }
            else if(chart.series[0].data.length >=12){
              let d = new Date(dateUTC);
              d.setMonth(d.getMonth() - 11);
              const PrevYear = new Date(d.toLocaleDateString())
              chart.xAxis[0].setExtremes(
                PrevYear.getTime(),
                lastDataPoint.getTime(),
                true
              );
            }
          }
        }
      },
      tooltip: {
        shared: false,
        backgroundColor: '#ffff',
        borderColor: '#ffff',
        borderRadius: 4,
        useHTML :true,
        positioner: function(labelWidth, labelHeight, point) {
          let tooltipX = point.plotX - 20;
          let tooltipY = point.plotY - 50;
          if(tooltipX > 800){
            tooltipX = point.plotX - 130
          }
          return {
              x: tooltipX,
              y: tooltipY
          };
        },
        formatter: function() {
          let chart:any = this;
          let date:any = new Date(chart.x);
          let month = date.toLocaleString('en-US', { month: 'short', timeZone: 'UTC' });
          if(date.getDate() == 2 || component.tceChart.switchType == 'Yearly'){
            month = date.getFullYear();
          }
          let html = '<b style="padding:10px 16px;color:#27364B;font-size:16px;background-color: #fff">' + month +' TCE'+ ': $ '  + formatNumber(chart.y.toFixed(0),'en','1.0-2') + '</b>';
          return html;
        }
      },
      
      series: [{
        data: this.tceChart.data,
        type: 'area',
        marker: {
          enabled: true,
          radius: 3
        },
        color: {
          linearGradient: { x1:0, x2: 0, y1: 0, y2: 1 },
          stops: [
            [0, 'rgb(148, 163, 184,0.3)'],
            [1, 'rgb(148, 163, 184,0.01)'],
          ]
        }
      }]
    }
    this.loadPlotLine();
  }

  /* xAxis label dynamic data */
  xAxisTickPositioner(axis) {   
    let positions:number[] = [];
    let data:any = axis;
    let min:any = new Date(data.min);
    let max:any = new Date(data.max);

    let dataMin:any = new Date(data.dataMin);
    let dataMax:any = new Date(data.dataMax);

    if(this.tceChart.switchType == 'Yearly'){
      let fullYear: number = dataMin.getFullYear();
      while (fullYear <= dataMax.getFullYear()) {
          positions.push(Date.UTC(fullYear, 0, 2));
          fullYear++;
      }
    }
    else{
      /* Walk every month between the visible extremes so multi-year ranges keep a tick per month.
         UTC getters are required because the positions themselves are built with Date.UTC. */
      let year: number = min.getUTCFullYear();
      let month: number = min.getUTCMonth();
      const lastPosition: number = Date.UTC(max.getUTCFullYear(), max.getUTCMonth());
      let position: number = Date.UTC(year, month);
      while (position <= lastPosition) {
        positions.push(position);
        month++;
        if(month > 11){
          month = 0;
          year++;
        }
        position = Date.UTC(year, month);
      }
    }
    return positions;
  }
  
  loadPlotLine(){
    if(this.chart){
      let chart = this.chart;
      if(chart && chart?.series && chart?.series?.length > 0){
        chart.yAxis[0].removePlotLine('ytdTce');
        chart.yAxis[0].removePlotLine('lastMonthTce');
        chart.yAxis[0].addPlotLine(
          {
            value: this.tceChart.ytdTce,
            color: '#7FC8F8',
            dashStyle: 'Dash',
            width: 4,
            id:'ytdTce',
        });
        if(this.tceChart.tceChartAction == 'ytd' && this.tceChart.switchType == "Monthly") {
          chart.yAxis[0].addPlotLine(
          {
            value: this.tceChart.lastMonthTce,
            color: '#788496',
            dashStyle: 'LongDash',
            id:'lastMonthTce',
            lastMonthLabel:this.tceChart.lastMonthTceLabel,
            width: 0,
            label: {
              align:'right',
              x: -50, //shifts right
              y:-40, //shifts top
              /* formatter: function () {
                let data:any = this;
                return data.options.lastMonthLabel + ' TCE: $ ' + formatNumber(data.options.value.toFixed(0),'en','1.0-2')
              }, */
              style: {
                color: '#27364B',
                fontWeight: '700',
                fontSize: '16px',
                lineHight:'24px',
                whiteSpace: '0.2px',
              }
            }
          },
          );
        }
      }
      console.log('loadPlotLine', chart.yAxis)
    }    
  }

  loadPlotLineNetPoolOut(){
    if(this.chartNetPoolOut){
      let chart = this.chartNetPoolOut;
      if(chart?.series?.length > 0){
        chart.yAxis[0].removePlotLine('ytdNetPoolOut');
        chart.yAxis[0].removePlotLine('lastMonthNetPoolOut');
        chart.yAxis[0].addPlotLine(
          {
            value: this.netPooloutPerOpDayChart.ytdNetPoolout,
            color: '#7FC8F8',
            dashStyle: 'Dash',
            width: 4,
            id:'ytdNetPoolOut',
        });
        if(this.tceChart.tceChartAction == 'ytd' && this.tceChart.switchType == "Monthly") {
          chart.yAxis[0].addPlotLine(
          {
            value: this.netPooloutPerOpDayChart.lastMonthNetPoolout,
            color: '#788496',
            dashStyle: 'LongDash',
            id:'lastMonthNetPoolOut',
            lastMonthLabel:this.netPooloutPerOpDayChart.lastMonthNetPooloutLabel,
            width: 0,
            label: {
              align:'right',
              x: -50, //shifts right
              y:-40, //shifts top
              /* formatter: function () {
                let data:any = this;
                return data.options.lastMonthLabel + ' Net Pool Out: $ ' + formatNumber(data.options.value.toFixed(0),'en')
              }, */
              style: {
                color: '#27364B',
                fontWeight: '700',
                fontSize: '16px',
                lineHight:'24px',
                whiteSpace: '0.2px',
              }
            }
          },
          );
        }
      }
      console.log('loadPlotLineNetPoolOut', chart.yAxis)
      this.loadPlotLine();  //need to call TCE chart plot line here to solve issue of first time chart load 
    }
  }
  
  selectedDate(event){
    this.tceChart.tceChartAction = 'finMonthYear';
    let startDate = new Date(event.startDate);
    let endDate = new Date(event.endDate);
    let sDate = startDate.getFullYear() + '-' + (startDate.getMonth() + 1).toString().padStart(2, "0") + '-01';
    let eDate = endDate.getFullYear() + '-' + (endDate.getMonth() + 1).toString().padStart(2, "0") + '-01';
    this.tceChart.selectedRange = {'startDate': sDate,'endDate': eDate};
    this.tceChartSelected(this.tceChart.tceChartAction);
  }

  selectedYear(event){
    this.tceChart.tceChartAction = 'finMonthYear';
    this.tceChart.selectedRange = {'startDate': event.startYear,'endDate': event.endYear};
    this.tceChartSelected(this.tceChart.tceChartAction);
  }

  monthYear(event){
    this.resetFilter();
    this.tceChart.switchType = event.itemName;
    if(event.itemName == 'Yearly'){
      this.tceChart.yearDateDropdown = true;
      this.tceChart.tceChartAction = 'all';
    }
    else{
      this.tceChart.monthDateDropdown = true;
      this.tceChart.tceChartAction = 'ytd';
    }    
    this.tceChartSelected(this.tceChart.tceChartAction);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    document.body.classList.remove('addDatePickerClass')
  }

  overlay(){
    let overlay = document.getElementsByClassName("cdk-overlay-pane");
    let topHeight = (document.documentElement.scrollTop > 20) ? 320 : 340;
    overlay[0]['style']['top'] = topHeight - document.documentElement.scrollTop+'px';
  }

}
